export const CommerceDataFr = {
    form: {
        inputs: {
            name: {
                label: "nom*",
                placeholder: "Ex. Maria Torres Martinez",
            },
            company: {
                label: "nom de l'entreprise*",
                placeholder: "Ex. Exemple SL",
            },
            email: {
                label: "e-mail*",
                placeholder: "Ex. exemple@gmail.com",
                error: "Format d'e-mail invalide*",
            },
            phone: {
                label: "téléphone*",
                placeholder: "Ex. +34 000 000 000",
                error: "Format de téléphone invalide*",
            },
            type: {
                label: "quel type d'entreprise êtes-vous?*",
                type_options: [],
            },
            location: {
                label: "sélectionnez l'emplacement de votre entreprise*",
            },
        },
        button: "Envoyer la demande",
    },
    success: {
        message: "Le formulaire a été soumis avec succès",
        button: "Envoyer une autre demande",
    },
    error: {
        message: "Une erreur s'est produite lors de la soumission de la demande",
        button: "Réessayer",
    },
};
